// import { Filter } from './utils/TreeQLBuilder';
export const RESOURCE_MAP: { [name: string]: { resource: string, filters: Array<[string, { __filter: string }]> } } = {
  // item2: {
  //   resource: 'user',
  //   filters: [
  //     ['m_type', { __filter: 'eq,teacher' }]
  //   ],
  // }
}
